/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown> }} Tournament_Wiz_Tip_Qr_BInputs */



/**
* | output |
* | --- |
* | "{action} puts a code on screen that players scan with their phone. Print it and leave it at the door." |
*
* @param {Tournament_Wiz_Tip_Qr_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_qr_b = /** @type {((inputs: Tournament_Wiz_Tip_Qr_BInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Qr_BInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.action} affiche un code que les joueurs scannent avec leur téléphone. Imprimez-le et laissez-le à l'accueil.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.action} muestra en pantalla un código que los jugadores escanean con el móvil. Imprímalo y déjelo en la puerta.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.action} mostra na tela um código que os jogadores escaneiam com o celular. Imprima e deixe na entrada.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.action} mostra a schermo un codice che i giocatori scansionano col telefono. Stampalo e lascialo all'ingresso.`)
	return /** @type {LocalizedString} */ (`${i?.action} puts a code on screen that players scan with their phone. Print it and leave it at the door.`)
});